import React, { useContext } from 'react'
import SubNavbar from '../components/SubNavbar'
import Navbar from '../components/Navbar'

import { CartProvider, useCart } from "react-use-cart";
import { apiValue } from '../Data/AllData';

function Page() {
  const { addItem } = useCart();

  const products = useContext(apiValue);


  return (
    <div>
      <div className='section properties'>
        <div className='container'>
          <div className='row properties-box'>
            {products.map((item) => (
              <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
                <div className="item">
                  <a href="property-details.html"><img src={item.images[0]} alt="" style={{ height: "300px" }} /></a>
                  <span className="category">{item.title}</span>
                  <h6>${item.price}</h6>
                  <h4><a href="property-details.html">{item.category}</a></h4>
                  <ul>
                    <li>Brand: <span>{item.brand}</span></li>
                    <li>Rating: <span>{item.rating}</span></li>
                    <li>Stock: <span>{item.stock}</span></li>
                    <li>Sku: <span>{item.sku}</span></li>
                  </ul>
                  <div className="main-button">
                    <button onClick={() => addItem(item)}>Add To Cart</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}



function AllShop() {
  return (
    <CartProvider>
      <SubNavbar />
      <Navbar />
      <Page />
    </CartProvider>
  );
}
export default AllShop